import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import logo from "../../component/asset/image/skyflypark logo png.png";
import "./Header.css";
import { WAIVER_REGESTRATION_LINK } from "../../Constant/Global";

function Header() {
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavToggle = () => {
    setExpanded(!expanded);
  };

  const handleNavClose = () => {
    setExpanded(false);
  };

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      expanded={expanded}
      className={`${scrolled || expanded ? "bg_Color" : ""} ${
        location.pathname === "/offer_prices" ||
        location.pathname === "/activity_adventure" ||
        location.pathname === "/photo_videos"
          ? ""
          : "position-fixed"
      } navbar-main w-100`}
      style={{
        backgroundColor:
          location.pathname === "/offer_prices" ||
          location.pathname === "/activity_adventure" ||
          location.pathname === "/photo_videos"
            ? "black"
            : "",
      }}
      // style={{
      //   boxShadow: "rgb(83 81 81 / 80%) 1px 0px 5px 0px",
      // }}
    >
      <Container
        fluid
        // style={{ backgroundColor: "black" }}
      >
        <Link to="/" onClick={handleNavClose}>
          <img src={logo} className="logo_size img-fluid" alt="logo" />
        </Link>

        {/* Toggle Button with Close Icon */}
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={handleNavToggle}
        >
          {expanded ? <CloseIcon size="20" /> : <MenuIcon size="20" />}
        </Navbar.Toggle>

        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto"></Nav>
          <Nav className="fs_nav">
            <Nav.Link
              className={`${
                location.pathname === "/" ? "active login-nav home_btn" : ""
              }`}
              onClick={handleNavClose}
            >
              {location.pathname === "/" && (
                <span className="text-center ms-2 arrow-icon">
                  <ArrowDropDownIcon fontSize="large" />
                </span>
              )}
              <Link className="login-link active" to="/">
                Home
              </Link>
            </Nav.Link>
            <Nav.Link
              className={`${
                location.pathname === "/about"
                  ? "active login-nav home_btn"
                  : ""
              }`}
              onClick={handleNavClose}
            >
              {location.pathname === "/about" && (
                <span className="text-center ms-2 arrow-icon">
                  <ArrowDropDownIcon fontSize="large" />
                </span>
              )}
              <Link className="login-link active" to="/about">
                About Us
              </Link>
            </Nav.Link>
            <Nav.Link
              className={`${
                location.pathname === "/offer_prices" ? "active login-nav" : ""
              }`}
              onClick={handleNavClose}
            >
              {location.pathname === "/offer_prices" && (
                <span
                  className="text-center arrow-icon"
                  style={{ marginLeft: "36px" }}
                >
                  <ArrowDropDownIcon fontSize="large" />
                </span>
              )}
              <Link className="login-link active" to="/offer_prices">
                Offer & Prices
              </Link>
            </Nav.Link>
            <Nav.Link
              className={`${
                location.pathname === "/activity_adventure"
                  ? "active login-nav"
                  : ""
              }`}
              onClick={handleNavClose}
            >
              {location.pathname === "/activity_adventure" && (
                <span className="text-center ms-5 arrow-icon">
                  <ArrowDropDownIcon fontSize="large" />
                </span>
              )}
              <Link className="login-link active" to="/activity_adventure">
                Activity & Adventure
              </Link>
            </Nav.Link>
            <Nav.Link
              className={`${
                location.pathname === "/photo_videos" ? "active login-nav" : ""
              }`}
              onClick={handleNavClose}
            >
              {location.pathname === "/photo_videos" && (
                <span
                  className="text-center arrow-icon"
                  style={{ marginLeft: "37px" }}
                >
                  <ArrowDropDownIcon fontSize="large" />
                </span>
              )}
              <Link className="login-link active" to="/photo_videos">
                Photo & Videos
              </Link>
            </Nav.Link>
            <div className="nav-link ps-0">
              <Link
                to={WAIVER_REGESTRATION_LINK}
                target="_blank"
                className="sign_link me-0"
                onClick={handleNavClose}
              >
                Waiver Registration
              </Link>
            </div>
          </Nav>
          <div className="contact_btn_div">
            <Link
              to="/contact"
              className="contact-btn"
              onClick={handleNavClose}
            >
              Contact
            </Link>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
